export default [
  {
    path: '/zjd/bankCard', // 银行卡管理
    name: 'bankCard',
    component: () => {
      return import(
        /* webpackChunkName: "bankCard" */ '@/views/bankcard/bankCard.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/addBCard', // 添加银行卡
    name: 'addBCard',
    component: () => {
      return import(
        /* webpackChunkName: "bankCard" */ '@/views/bankcard/addBCard.vue'
      )
    }
  },
  {
    path: '/zjd/countrySearch', // 添加银行卡
    name: 'countrySearch',
    component: () => {
      return import(
        /* webpackChunkName: "bankCard" */ '@/views/bankcard/countrySearch.vue'
      )
    }
  },
  {
    path: '/zjd/search', // 选择城市、选择银行
    name: 'search',
    component: () => {
      return import(
        /* webpackChunkName: "search" */ '@/views/bankcard/search.vue'
      )
    }
  },
  {
    path: '/zjd/searchBranchBank', // 选择城市、选择银行
    name: 'searchBranchBank',
    component: () => {
      return import(
        /* webpackChunkName: "search" */ '@/views/bankcard/searchBranchBank.vue'
      )
    }
  }
]
